module.exports = {
	title: "separator",
	icon: "<i class='vw-separator'></i>"
}
